import { render } from "./TermsTemplate.vue?vue&type=template&id=2dca8344&scoped=true&ts=true"
import script from "./TermsTemplate.vue?vue&type=script&lang=ts"
export * from "./TermsTemplate.vue?vue&type=script&lang=ts"

import "./TermsTemplate.vue?vue&type=style&index=0&id=2dca8344&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dca8344"]])

export default __exports__